import {sortBy, filter, createSelector} from 'helpers';
import {byProjectId} from './goals';
import {id, createdDateNegative} from 'store/common';
import {RootState} from 'store/root-state.type';

export const project = createSelector(
  [(state: RootState) => state.goals.types, id],
  (projects, id = '') => projects[id],
);

export const projects = createSelector(
  [state => state.goals.types, byProjectId],
  (projects, goals) => sortBy(projects, createdDateNegative).map(project => ({
    ...project,
    goals: goals[project.id],
    completed: filter(goals[project.id], {status: 'Completed'}).length,
  })),
);
